import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApiSearchText } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
const TaxesListExpense = ({
  setDataSourceTax,
  dataSourceTax,
  setDataSourceAdvances,
  dataSourceExpenses,
  t,
  form,
}) => {
  const [count, setCount] = useState(0);
  const [setTextAccount, setSetTextAccount] = useState('');
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getAccountSearch, setTextAccount],
    queryFn: () =>
      getSearchApiSearchText({ type: 'Account', searchTxt: setTextAccount }),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.accounts,
      dataIndex: 'account_head',
      render: (text, record, index) => (
        <Select
          placeholder={t.accounts}
          style={{ width: '100%' }}
          filterOption={false}
          showSearch
          popupMatchSelectWidth={false}
          allowClear
          value={record.account_head}
          onSearch={(value) => {
            setSetTextAccount(value);
          }}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
            option: item,
          }))}
          onChange={(value, option) => {
            console.log(option, 'fieuwhfieuwfhweif');
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              account_head: value,
              description: option?.option?.description,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.rate,
      dataIndex: 'rate',
      render: (text, record, index) => (
        <Input
          placeholder={t.rate}
          style={{ width: '100%' }}
          value={record.rate}
          type="number"
          min={0}
          onChange={(e) => {
            const totalAmount = dataSourceExpenses?.reduce(
              (acc, item) => acc + Number(item?.amount),
              0
            );
            // console.log(totalAmount,"totalAmount",dataSourceExpenses,"dataSourceExpenses");

            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              rate: e.target.value,
              tax_amount: totalAmount * (Number(e.target.value) / 100),
              total: totalAmount + Number(e.target.value),
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.TaxAmount,
      dataIndex: 'tax_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.TaxAmount}
          style={{ width: '100%' }}
          value={record.tax_amount}
          type="number"
          min={0}
          disabled
          onChange={(e) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              tax_amount: e.target.value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.Total,
      dataIndex: 'total',
      render: (text, record, index) => (
        <Input
          placeholder={t.Total}
          style={{ width: '100%' }}
          value={record.total}
          type="number"
          min={0}
          disabled
          onChange={(e) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              total: e.target.value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.description,
      dataIndex: 'description',
      render: (text, record, index) => (
        <Input
          placeholder={t.description}
          style={{ width: '100%' }}
          value={record.description}
          onChange={(e) => {
            const newDataSource = [...dataSourceTax];
            newDataSource[index] = {
              ...newDataSource[index],
              description: e.target.value,
            };
            setDataSourceTax(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      uom: '',
      conversion_factor: '',
    };
    setDataSourceTax((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceTax.filter((item) => item.key !== key);
    setDataSourceTax(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceTax}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default TaxesListExpense;
